var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18IcPhotoSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5454545,3 L2.45454545,3 C1.72727273,3 1,3.66666667 1,4.33333333 L1,13.6666667 C1,14.4 1.65454545,15 2.45454545,15 L15.5454545,15 C16.2727273,15 17,14.3333333 17,13.6666667 L17,4.33333333 C17,3.66666667 16.2727273,3 15.5454545,3 Z M3.90909091,12.1811112 L6.45454545,8.90861119 L8.27272727,11.0975501 L10.8181818,7.81777785 L14.0909091,12.1811112 L3.90909091,12.1811112 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18IcPhotoSelect);
export default __webpack_public_path__ + "static/media/18_ic_photo_select.99369515.svg";
export { ForwardRef as ReactComponent };